import * as React from 'react';
import { FC, memo, useMemo, ReactElement, useState } from 'react';
import PropTypes from 'prop-types';
import ImageEye from '@material-ui/icons/Add';

import { Button } from 'react-admin';

import dataProvider from '../dataProvider'

const API_URL = process.env.REACT_APP_API_HOSTNAME;

class ShowButton extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            nb: 0
        }
    }

    render() {

        const {
            resource,
            basePath = '',
            icon = defaultIcon,
            label = 'Create Sample Archo',
            record,
            scrollToTop = true,
            ...rest
        } = this.props

        const deletedFields = this.props.deletedFields || []
        const tranformFields = this.props.tranformFields || []

        return (
            <div style={{
                position: 'relative',
            }}>
                <Button
                    label={label}
                    disabled={this.state.disabled}
                    onClick={() => {
                        const copied = {...record}
                        delete copied.id
                        deletedFields.forEach(e => delete copied[e])
                        tranformFields.forEach(e => copied[e.f] = e.t(copied[e.f]))
                        console.log(copied)
                        dataProvider.customs.createWebsiteArcho().then(() => window.location.reload())
                    }}
                    {...(rest)}
                >
                    <ImageEye />
                </Button >
            </div>
        )
    }
}

const defaultIcon = <ImageEye />;

ShowButton.propTypes = {
    basePath: PropTypes.string,
    icon: PropTypes.element,
    label: PropTypes.string,
    record: PropTypes.any,
    scrollToTop: PropTypes.bool,
};

const PureShowButton = memo(
    ShowButton,
    (props, nextProps) =>
        (props.record && nextProps.record
            ? props.record.id === nextProps.record.id
            : props.record == nextProps.record) && // eslint-disable-line eqeqeq
        props.basePath === nextProps.basePath &&
        props.to === nextProps.to &&
        props.disabled === nextProps.disabled
);

export default PureShowButton;